export default "__VITE_ASSET__e070d019__"